let globalTrackActivity: any = null;
let eventQueue: Array<{ type: string; data: any }> = [];

export const initializeGlobalActivityTracker = () => {
  // This function will be called once to set up the global tracker.
  // The actual event listeners will be set up when setupGlobalTracking is called.
};

export const setupGlobalTracking = (trackActivity: any) => {
  globalTrackActivity = trackActivity;

  // Flush queued events
  if (eventQueue.length > 0) {
    eventQueue.forEach((event) => {
      trackActivity(event.type, event.data);
    });
    eventQueue = [];
  }

  // Track button clicks
  const handleClick = (e: any) => {
    if (e.target.tagName === 'BUTTON') {
      const buttonText = e.target.textContent?.trim();
      if (buttonText) {
        trackActivity('button_click', {
          buttonText: buttonText
        });
      }
    }
  };

  // Track form submissions
  const handleSubmit = (e: any) => {
    trackActivity('form_submit', {
      formId: e.target.id
    });
  };

  // Add event listeners
  document.addEventListener('click', handleClick, true);
  document.addEventListener('submit', handleSubmit, true);

  // Return cleanup function
  return () => {
    document.removeEventListener('click', handleClick, true);
    document.removeEventListener('submit', handleSubmit, true);
  };
};

export const trackLoginActivity = (userData?: any) => {
  if (globalTrackActivity) {
    globalTrackActivity('login_activity', userData || {});
  } else {
    eventQueue.push({ type: 'login_activity', data: userData || {} });
  }
};

export const getGlobalActivityTracker = () => globalTrackActivity;
